import Col from "react-bootstrap/Col";
import Image from "next/image";

const Founder = ({ founder, image, children, flipped = false }) => {
  return (
    <div className="founder-row d-flex justify-content-between flex-wrap">
      <Col
        md={4}
        className={`d-flex align-items-center ${
          flipped ? "order-md-2" : "order-md-1"
        }`}>
        <div
          className={`position-relative founder-image ${
            flipped ? "flipped" : ""
          }`}>
          <Image src={image} width={304} height={304} unoptimized={true} />
        </div>
      </Col>
      <Col
        className={`d-flex align-items-center ${
          flipped ? "order-md-1" : "order-md-2"
        }`}
        md={6}>
        <div className="w-100">
          <h2 className="text-primary">{founder}</h2>
          {children}
        </div>
      </Col>
    </div>
  );
};

export default Founder;
